module.exports = __webpack_public_path__ + "static/designsystemteam.c7f4fec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designsystemteam.png
// module id = 407
// module chunks = 65579394461380